import { Grid, makeStyles } from '@material-ui/core';
import { Typography } from 'components';

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: '#EDF0F1',
    borderRadius: 8,
    padding: 16,
    width: '100%',
  },
  grid: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  text: {
    fontWeight: '500 !important',
  },
}));

const TableHeader = ({ columns }) => {
  const classes = useStyles();

  return (
    <Grid container className={classes.container}>
      {columns.map((e, index) => (
        <Grid item key={index} xs={e.flex} className={classes.grid}>
          <Typography variant="body1" className={classes.text}>
            {e.label}
          </Typography>
        </Grid>
      ))}
    </Grid>
  );
};

export default TableHeader;
